/*global process*/
import React, { useState, useContext, useEffect } from "react";
import "./MainHeader.css";
import { ECLDropDown, ECLSwitch, ECLThemeImage } from "../../../eclComponents";
import { Link, useLocation } from "react-router-dom";
import {
   UserPreferencesContext,
   AuthContext,
} from "../../../utilities/contexts";
import { staticURL } from "../../../utilities/requests";
import { translate } from "../../../utilities/Translate";

// fetch the sandbox help doc json
async function getObject(url) {
   try {
      const response = await fetch(url);
      if (!response.ok) {
         throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      return data;
   } catch (error) {
      console.error("Could not fetch the object:", error);
      return null;
   }
}

export default function MainHeader() {
   const location = useLocation();
   const [wideView, setWideView] = useState(false);
   const userPrefs = useContext(UserPreferencesContext);
   const auth = useContext(AuthContext);
   const [sandboxHelpDoc, setSandboxHelpDoc] = useState(null);

   // Fetch helpDoc JSON
   useEffect(() => {
      getObject(`${window.location.origin}/helpdoc/helpmap.json`).then(
         (object) => {
            setSandboxHelpDoc(object);
         },
      );
   }, []);

   //ONLY FOR APPS
   //Check to see if view has been chosen previously by user
   useEffect(() => {
      if (window.localStorage.getItem("appWidthPreference") === "wide-view") {
         setWideView(true);
      } else {
         setWideView(false);
      }
   }, []);

   function updateWideView() {
      //update local storage
      if (!wideView) {
         window.localStorage.setItem("appWidthPreference", "wide-view");
      } else {
         window.localStorage.setItem("appWidthPreference", "narrow-view");
      }

      //update UI
      const widthContainer = document.getElementById("app-width-container");
      if (widthContainer) {
         if (!wideView) {
            widthContainer.classList.add("wide-view");
         } else {
            widthContainer.classList.remove("wide-view");
         }
         //Need to dispatch this event for resizing tables, probably will come in useful for other things eventually
         const widthToggleEvent = new Event("widthToggled");
         widthContainer.dispatchEvent(widthToggleEvent);
      }
      setWideView(!wideView);
   }

   return (
      <header className="main-header" id={"site-main-header"}>
         <Link to="sourceone/" alt="Home page">
            <img
               src={staticURL + "Logos/S1-EKPS-small-light.svg"}
               className="logo-img"
            />
         </Link>
         <div>
            {/* Links to the homepage until help doc has been uploaded */}
            {sandboxHelpDoc && (
               <a
                  href={`${window.location.origin}/helpdoc/${sandboxHelpDoc.chapters[6]}`}
                  id="site-main-header"
                  target="_blank"
                  rel="noopener noreferrer"
               >
                  <ECLThemeImage
                     fontAwesome="circle-question"
                     colorOverride="white"
                     style={{ width: "25px", height: "25px" }}
                  />
               </a>
            )}
            <ECLDropDown
               containerId={"site-main-header"}
               menuWidth={350}
               playwright="main-header"
               trigger={
                  <ECLThemeImage fontAwesome="bars" colorOverride="white" />
               }
            >
               <Link to="sourceone/applications">
                  {translate("Applications")}
               </Link>
               {process.env.BUILD !== "production" && (
                  <Link to="sourceone/sandbox">{translate("Sandbox")}</Link>
               )}
               {location.pathname.includes("/app/") ? (
                  <div
                     id="wide-view-switch-container"
                     style={{ display: "flex", padding: "0 var(--padding)" }}
                  >
                     <p>{translate("Full Width")}</p>
                     <ECLSwitch
                        toggle={wideView}
                        handleToggle={updateWideView}
                     />
                  </div>
               ) : null}
               <div
                  id="theme-toggle"
                  style={{ display: "flex", padding: "0 var(--padding)" }}
               >
                  <p>{translate("Theme")}</p>
                  <ECLSwitch
                     playwrightId="theme-switch"
                     toggle={userPrefs.theme === "Dark" ? true : false}
                     handleToggle={userPrefs.themeToggle}
                  />
               </div>
               <Link to="sourceone/settings">{translate("User Settings")}</Link>
               <Link to="sourceone/about">{translate("About Page")}</Link>
               <button
                  onClick={(e) => {
                     e.preventDefault();
                     auth.logout();
                  }}
               >
                  {translate("Log Out")}
               </button>
            </ECLDropDown>
         </div>
      </header>
   );
}
